import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { StyledButtonGroup } from './button-group.styles';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Button group component.
 *
 * @author Mikhail Siutsou
 * @function ButtonGroup
 * @category components
 * @return {FC} button group component.
 */
var ButtonGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(StyledButtonGroup, _objectSpread({
    ref: ref
  }, props));
});
ButtonGroup.displayName = 'ButtonGroup';
export { ButtonGroup };